import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Calendar, Users, Compass } from "lucide-react";
import { ASSETS } from "../lib/constants";
import Gallery from "../components/Gallery";

export default function About() {
  const { t } = useTranslation();
  return (
    <section data-testid="about-page" className="bg-brand-black py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-7">
            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-brand-orange">
              {t("nav.about")}
            </span>
            <h1 className="mt-2 font-display text-5xl uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
              {t("about.title")}
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-white/85">{t("about.lead")}</p>
            <p className="mt-4 text-base leading-relaxed text-white/70">{t("about.body")}</p>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-5"
          >
            <div className="aspect-[4/5] overflow-hidden border-2 border-brand-orange hard-shadow-orange">
              <img src={ASSETS.lifestyle1} alt="" className="h-full w-full object-cover" />
            </div>
          </motion.div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-3">
          {[
            { icon: <Calendar />, title: t("about.feat1Title"), body: t("about.feat1Body") },
            { icon: <Users />, title: t("about.feat2Title"), body: t("about.feat2Body") },
            { icon: <Compass />, title: t("about.feat3Title"), body: t("about.feat3Body") },
          ].map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="border-2 border-brand-orange bg-brand-black p-6 hard-shadow"
            >
              <div className="mb-3 inline-flex h-10 w-10 items-center justify-center bg-brand-orange text-white">
                {c.icon}
              </div>
              <h3 className="font-display text-2xl uppercase">{c.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-white/75">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <Gallery variant="reverse" />
    </section>
  );
}
